import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ListGroup, ListGroupItem, Input } from 'reactstrap';
import styles from './CategoryTreeModal.scss';

export default class CategoryTreeModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    categories: PropTypes.array.isRequired,
  };

  state = {
    searchTerm: '',
  }

  changeSearchTerm = (e) => this.setState({ searchTerm: e.target.value });
  selectCategory = category => () => {
    this.props.onSelect(category.id);
    this.props.onToggle();
  }

  renderFilteredList() {
    let categories = [];
    if (this.state.searchTerm === '') {
      categories = this.props.categories;
    } else {
      categories = this.props.categories.filter(e => e.name_with_path.toLocaleLowerCase().indexOf(this.state.searchTerm) > -1);
    }

    return (
      <ListGroup>
        {categories.map(cat =>
          <ListGroupItem
            key={cat.id}
            onClick={this.selectCategory(cat)}
          >
            <div className="row">
              <div className="col-9">
                {cat.name_with_path}
              </div>
              <div className="col-3 text-right">
                {cat.market_name} Plan
              </div>
            </div>
          </ListGroupItem>
        )}
      </ListGroup>
    );
  }

  render() {
    const { isOpen, onToggle } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={onToggle} size="lg" className={styles.modal}>
        <ModalHeader toggle={onToggle}>Select Category</ModalHeader>
        <ModalBody>
          <Input
            placeholder="Filter category tree..."
            value={this.state.searchTerm}
            onChange={this.changeSearchTerm}
          />
          <hr/>
          {this.renderFilteredList()}
        </ModalBody>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/CategoryTreeModal.jsx